import { HttpClient } from '@angular/common/http';
import { Component, DestroyRef, OnInit, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { INavContent } from '@garmin/components-global-web';
import { NavigationTreeService } from '../../../core/services/navigation-tree/navigation-tree.service';
import { NAVIGATION_TREE } from '../../../modules/app-routing-structure';

@Component({
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FullLayoutComponent implements OnInit {
  navigationTree = signal<INavContent[]>([]);

  private readonly navigationTreeService = inject(NavigationTreeService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly httpClient = inject(HttpClient);

  buildTime?: string;

  ngOnInit(): void {
    this.navigationTreeService
      .buildAuthorizedNavigationTree(NAVIGATION_TREE)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((authorizedNavigationTree) => {
        this.navigationTree.set(authorizedNavigationTree);
      });

    this.httpClient.get('/assets/build-time.txt', { responseType: 'text' }).subscribe({
      next: (data) => (this.buildTime = data),
      error: () => {
        console.info('No build-time.txt found.');
      }
    });
  }
}
